import React from 'react'
import HeaderImage from '../assets/images/Header.jpg'

const Service = () => {
  return (
    <div className="min-h-screen bg-transparent pt-20">
      <div className="max-w-[1440px] mx-auto px-4 py-12">
        {/* Başlık */}
        <div 
          className="text-white p-8 rounded-lg mb-10 relative overflow-hidden"
          style={{
            backgroundImage: `url(${HeaderImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <h1 className="text-3xl md:text-4xl font-bold text-center relative z-10">Teknik Servis ve Revizyon Devreye Alma</h1>
        </div>

        {/* Teknik Servis Kartı */}
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 mb-10 relative z-10">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <img
              src={require('../assets/images/teknik-servis/KAS Webinar_Teaser Image_600x325_0.jpg')}
              alt="Teknik Servis"
              className="w-full max-w-[520px] object-cover rounded-lg"
            />
            <div className="flex-1">
              <h2 className="text-2xl font-semibold text-[#2E3192] mb-4">Teknik Servis</h2>

              <h3 className="text-lg font-semibold text-[#2E3192] mb-2">Teknik Servis Hizmetlerimiz</h3>
              <p className="text-gray-700 mb-4">
                Müşteri memnuniyetini ön planda tutarak sunduğumuz teknik servis hizmetlerimizle, cihazlarınızın en kısa sürede ve en doğru şekilde onarılmasını sağlıyoruz.
                Alanında uzman ekibimizle, arıza tespiti, bakım, onarım ve parça değişimi gibi tüm teknik ihtiyaçlarınıza profesyonel çözümler sunuyoruz.
              </p>

              <h4 className="text-base font-semibold text-[#2E3192] mb-2">Hizmet Kapsamımız</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
                <li>Servo Sürücü ve Motor tamiri</li>
                <li>PLC ve HMI Tamiri</li>
                <li>Elektronik cihaz arıza tespiti</li>
                <li>Periyodik bakım ve temizlik hizmetleri</li>
                <li>Yerinde servis ve teknik destek</li>
                <li>Program ve Parametre desteği</li>
                <li>Uzaktan bağlantılı servis desteği</li>
              </ul>

              <h4 className="text-base font-semibold text-[#2E3192] mb-2">Neden Bizi Tercih Etmelisiniz?</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
                <li>Uzman Kadro: Deneyimli teknisyenlerle kaliteli hizmet</li>
                <li>Hızlı Müdahale: Zaman kaybını önleyen hızlı servis</li>
                <li>Orijinal Parça Kullanımı: Güvenli ve garantili onarım</li>
                <li>Şeffaf Fiyatlandırma: Sürpriz maliyetler olmadan net fiyatlar</li>
                <li>Müşteri Memnuniyeti: Servis sonrası destek ve danışmanlık</li>
              </ul>

              <p className="text-gray-800 font-medium">Cihazlarınız bizimle emin ellerde. Teknik servis ihtiyaçlarınız için hemen bizimle iletişime geçin!</p>
            </div>
          </div>
        </div>

        {/* Revizyon & Devreye Alma Kartı */}
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 relative z-10">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <img
              src={require('../assets/images/teknik-servis/kas_diagram_of_components.jpg')}
              alt="Revizyon ve Devreye Alma"
              className="w-full max-w-[520px] object-cover rounded-lg"
            />
            <div className="flex-1">
              <h2 className="text-2xl font-semibold text-[#2E3192] mb-4">Revizyon ve Devreye Alma Hizmetleri</h2>
              <p className="text-gray-700 mb-4">
                Otomasyon sistemlerinizin verimli ve kesintisiz çalışması için uzman kadromuzla revizyon ve devreye alma hizmetleri sunuyoruz.
                Sahip olduğunuz marka ve modellerin sisteminize entegrasyonu, yeniden devreye alınması ve modernizasyonu konusunda yanınızdayız.
              </p>

              <h4 className="text-base font-semibold text-[#2E3192] mb-2">Hizmet Kapsamımız</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
                <li>Otomasyon Uyarlamaları: Uzmanı olduğumuz marka ve modellerin sisteminize sorunsuz adaptasyonu</li>
                <li>Yazılım ve Parametre Desteği: Programsal değişiklikler, parametrik ayarlamalar ve özel yazılım çözümleri</li>
                <li>Modernizasyon Çözümleri: Üretimi durmuş, piyasada bulunması zor ürünlerin yeni nesil ve garantili alternatiflerle değiştirilmesi</li>
                <li>Hızlı Müdahale: Teknik ihtiyaçlarınıza en kısa sürede çözüm sunan dinamik servis yaklaşımı</li>
              </ul>

              <h4 className="text-base font-semibold text-[#2E3192] mb-2">Neden Biz?</h4>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
                <li>Deneyimli mühendis ve teknisyen kadrosu</li>
                <li>Marka bağımsız çözüm üretme kabiliyeti</li>
                <li>Kaliteli, garantili ve uzun ömürlü ürün kullanımı</li>
                <li>Proje bazlı veya acil müdahale seçenekleri</li>
                <li>Süreç sonunda test ve raporlama desteği</li>
              </ul>

              <p className="text-gray-800 font-medium">Sisteminizin performansını artırmak, arızaları önlemek ve üretim sürekliliğini sağlamak için bizimle iletişime geçin. Revizyon ve devreye alma süreçlerinde profesyonel destek için buradayız.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Service
